import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Hero, Features, Services, Portfolio, Testimonials, Pricing, FAQ, CTA } from "@/components/sections";
export function HomePage() {
    return (_jsxs(_Fragment, { children: [_jsx(Hero, {}), _jsx(Features, {}), _jsx(Services, {}), _jsx(Portfolio, {}), _jsx(Testimonials, {}), _jsx(Pricing, {}), _jsx(FAQ, {}), _jsx(CTA, {})] }));
}
